<h1>Trailers</h1>
<div class="p-grid" style="flex-direction: row-reverse;">
  <div class="p-col-12 p-xl-4">
    <div>
      <p-card header="Add Trailer">
        <form [formGroup]="trailerForm">
          <div class="p-grid">
            <div class="form-group p-col-6 p-md-4 p-xl-6">
              <label class="required">Trailer Number</label>
              <input formControlName="trailerNumber" id="trailerNumber" pInputText type="text"/>
              <error-block [field]="trailerForm.controls.trailerNumber" [messages]="{
                  required: 'Trailer Number is required.'}">
              </error-block>
            </div>
            <div class="form-group p-col-6 p-md-4 p-xl-6">
              <label class="required">Operation</label>
              <p-dropdown
                [options]="subinventories"
                appendTo="body"
                formControlName="siteSubinventoryId"
                optionLabel="name"
                optionValue="id"
                placeholder="-- Select --"
              ></p-dropdown>
              <error-block [field]="trailerForm.controls.siteSubinventoryId" [messages]="{
                  required: 'Operation is required.'}">
              </error-block>
            </div>
            <div class="form-group p-col-12 p-md-4 p-xl-12">
              <label class="required">Carrier</label>
              <div class="p-inputgroup">
                <p-dropdown [editable]="false" [filter]="true"
                            [options]="carrierSelects"
                            [resetFilterOnHide]="true"
                            [style]="{'width':'100%'}"
                            appendTo="body"
                            formControlName="carrierId" optionLabel="label" optionValue="value"
                            placeholder="-- Select Carrier --"></p-dropdown>
                <button (click)="showDialogToAddCarrier()" [disabled]="trailerForm.disabled" icon="pi pi-plus"
                        label="Add"
                        pButton type="button"></button>
              </div>
              <error-block [field]="trailerForm.controls.carrierId" [messages]="{
                required: 'Carrier is required.'
              }"></error-block>
              <app-add-carrier-form
                (update)="carrierSelectedChange($event)"
                [(displayDialogFromForm)]="displayCarrierDialog"
                [carriers]="carriers">
              </app-add-carrier-form>
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-xl-12">
              <label class="required" for="isInbound">Trailer Status</label>
              <p-selectButton
                [options]="trailerTypeOptions"
                inputId="isInbound"
                formControlName="isInbound"></p-selectButton>
                <error-block [field]="trailerForm.controls.isInbound" [messages]="{
                  required: 'Trailer Status is required.'
                }"></error-block>
            </div>
            <div class="form-group p-col-6 p-md-4 p-xl-6" *ngIf="!trailerForm.controls.isInbound.value">
              <label class="required" for="arrivedAtDate">Arrived Date</label>
              <p-calendar
                [showIcon]="true"
                class="form-control"
                formControlName="arrivedAtDate"
                name="arrivedAtDate">
              </p-calendar>
              <error-block [field]="trailerForm.controls.arrivedAtDate" [messages]="{
                required: 'Arrived Date is required.'
              }"></error-block>
            </div>
            <div class="form-group p-col-6 p-md-4 p-xl-6" *ngIf="!trailerForm.controls.isInbound.value">
              <label class="required" for="arrivedAtTime">Arrived Time</label>
              <time-entry
                [displaySeconds]="false"
                formControlName="arrivedAtTime"
                [timezone]="siteTimezone"
                name="arrivedAtTime">
              </time-entry>
              <error-block [field]="trailerForm.controls.arrivedAtTime" [messages]="{
                required: 'Arrived Time is required.'
              }"></error-block>
            </div>
          </div>

        </form>
        <div class="form-buttons">
          <p-button (onClick)="cancel()" label="Cancel" styleClass="p-button-secondary" title="Cancel"></p-button>
          <p-button
            (onClick)="createTrailer()"
            [label]="trailerForm.controls.isInbound.value ? 'Save & Create Inbound' : 'Save'"
            styleClass="p-button-success"
            title="Save"></p-button>
        </div>
      </p-card>
    </div>
  </div>
  <div class="p-col-12 p-xl-8">
    <p-card>
      <p-table
        #trailersTable
        [autoLayout]="true"
        [loading]="loading"
        [value]="filteredTrailers | async"
        dataKey="id">
        <ng-template let-columns pTemplate="header">
          <tr>
            <th>
              <button pButton type="button" icon="pi pi-refresh" [disabled]="loadingAllChecks" (click)="resetChecklist()" pTooltip="Reset Checklist" aria-label="Reset Checklist"></button>
            </th>
            <th pSortableColumn="carrier.carrierCode">
              Carrier
              <p-sortIcon field="carrier.carrierCode"></p-sortIcon>
            </th>
            <th pSortableColumn="trailerNumber">
              Trailer #
              <p-sortIcon field="trailerNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="trailerStatus">
              Status
              <p-sortIcon field="trailerStatus"></p-sortIcon>
            </th>
            <th></th> <!-- button -->
            <th pSortableColumn="siteSubinventoryId">
              Operation
              <p-sortIcon field="siteSubinventoryId"></p-sortIcon>
            </th>
            <th pSortableColumn="arrivedAt">
              Arrived
              <p-sortIcon field="arrivedAt"></p-sortIcon>
            </th>
            <th pSortableColumn="unloadedAt">
              Unloaded
              <p-sortIcon field="unloadedAt"></p-sortIcon>
            </th>
            <th pSortableColumn="loadedAt">
              Loaded
              <p-sortIcon field="loadedAt"></p-sortIcon>
            </th>
            <th pSortableColumn="departedAt">
              Departed
              <p-sortIcon field="departedAt"></p-sortIcon>
            </th>
            <th *ngIf="isAdmin | async"></th>
          </tr>
          <tr [formGroup]="searchForm">
            <th [pTooltip]="latestChecklistCheck?.lastChangedBy ? 'Last updated by: ' + latestChecklistCheck?.lastChangedBy : undefined" tooltipPosition="left">
              <time *ngIf="!!latestChecklistCheck" style="font-weight: normal;" aria-label="Trailer last checked at time" [dateTime]="latestChecklistCheck?.lastChanged?.toISO()">
                {{ latestChecklistCheck?.lastChanged | dateTimeToFormat:'M/d/yy' }}<br>
                {{ latestChecklistCheck?.lastChanged | dateTimeToFormat:'H:mm ZZZZ' }}
              </time>
            </th>
            <th>
              <input pInputText type="text" formControlName="scac" />
            </th>
            <th>
              <input pInputText type="text" formControlName="trailerNumber" />
            </th>
            <th>
              <p-dropdown
                formControlName="trailerStatus"
                [options]="trailerStatusArray"
                appendTo="body"
                [showClear]="true"
                placeholder="-- all --"></p-dropdown>
            </th>
            <th></th> <!-- button -->
            <th>
              <p-dropdown
                [options]="subinventories"
                appendTo="body"
                [showClear]="true"
                formControlName="siteSubinventoryId"
                optionLabel="name"
                optionValue="id"
                placeholder="-- all --"></p-dropdown>
            </th>
            <th>
              <p-calendar
                formControlName="arrivedAt"
                appendTo="body"
                [readonlyInput]="true"
                [showClear]="true">
              </p-calendar>
            </th>
            <th>
              <p-calendar
                formControlName="unloadedAt"
                appendTo="body"
                [readonlyInput]="true"
                [showClear]="true">
              </p-calendar>
            </th>
            <th>
              <p-calendar
                formControlName="loadedAt"
                appendTo="body"
                [readonlyInput]="true"
                [showClear]="true">
              </p-calendar>
            </th>
            <th>
              <p-calendar
                formControlName="departedAt"
                appendTo="body"
                [readonlyInput]="true"
                [showClear]="true">
              </p-calendar>
            </th>
            <th *ngIf="isAdmin | async"></th>
          </tr>
        </ng-template>
        <ng-template let-trailer pTemplate="body">
          <tr>
            <td class="centered">
              <span *ngIf="(loadingChecks | async)?.[trailer.id] || loadingAllChecks; else trailerCheck">
                <span class="pi pi-spin pi-spinner" style="font-size: 150%" aria-label="Processing trailer check" aria-live="assertive"></span>
              </span>
              <ng-template #trailerCheck>
                <p-checkbox  *ngIf="!((loadingChecks | async)?.[trailer.id]) && !loadingAllChecks"
                  [ngModel]="(checks | async)?.[trailer.id]?.checked"
                  [binary]="true"
                  [readonly]="true"
                  [pTooltip]="getCheckTooltipText((checks | async)?.[trailer.id])"
                  tooltipPosition="left"
                  (click)="checkTrailer(trailer)"
                  aria-label="Check Trailer"
                ></p-checkbox>
              </ng-template>
            </td>
            <td>{{ trailer.carrier.carrierCode }}</td>
            <td *ngIf="isAdmin | async; else readOnlyTrailerNum">
              <app-trailer-number-admin-input
                [trailer]="trailer"
                [shiftDate]="date"
                (onError)="refreshGrid()"
                (onUpdate)="handleTrailerUpdate($event)"
              ></app-trailer-number-admin-input>
            </td>
            <ng-template #readOnlyTrailerNum>
              <td>
                {{ trailer.trailerNumber }}
              </td>
            </ng-template>
            <td>
              <a *ngIf="showOutboundLink(trailer)" [routerLink]="getOutboundLoadUrl(trailer)" [queryParams]="{ fromTrailerForm: true }">{{ getTrailerStatus(trailer) }}</a>
              <a *ngIf="showInboundLink(trailer)" [routerLink]="getInboundLoadUrl(trailer)" [queryParams]="{ fromTrailerForm: true }">{{ getTrailerStatus(trailer) }}</a>
              <span *ngIf="!showInboundLink(trailer) && !showOutboundLink(trailer)">
                {{ getTrailerStatus(trailer) }}
              </span>
            </td>
            <td style="white-space: nowrap;">
              <button pButton
                *ngIf="showInboundLink(trailer)"
                (click)="unloadTrailer(trailer)"
                icon="pi pi-arrow-right"
                label="Unload"></button>
              <button pButton
                *ngIf="showOutboundLink(trailer)"
                (click)="shipLoadDialog(trailer)"
                icon="pi pi-arrow-right"
                label="Ship Load"></button>
              <button pButton
                *ngIf="canUpdateStatus(trailer)"
                (click)="updateStatus(trailer)"
                class="p-button-secondary"
                icon="pi pi-arrow-right"
                label="Mark Left"></button>
            </td>
            <td>{{ getSubInventoryName(trailer.siteSubinventoryId) }}</td>
            <td>{{ trailer.arrivedAt | dateTimeToTz:siteTimezone | dateTimeToFormat:'M/d/yy H:mm ZZZZ' }}</td>
            <td>{{ trailer.unloadedAt | dateTimeToTz:siteTimezone | dateTimeToFormat:'M/d/yy H:mm ZZZZ' }}</td>
            <td>{{ trailer.loadedAt | dateTimeToTz:siteTimezone | dateTimeToFormat:'M/d/yy H:mm ZZZZ' }}</td>
            <td>{{ trailer.departedAt | dateTimeToTz:siteTimezone | dateTimeToFormat:'M/d/yy H:mm ZZZZ' }}</td>
            <td *ngIf="isAdmin | async">
              <confirmation-button
                [iconsOnly]="true"
                [actionIcon]="'pi pi-times'" actionText="Delete"
                [confirmIcon]="'pi pi-times'" confirmText="Delete"
                cancelIcon="pi pi-minus-circle" cancelText="Cancel"
                (actionConfirmed)="deleteTrailer(trailer)">
              </confirmation-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td [attr.colspan]="(isAdmin | async) ? '11' : '10'">
              Showing {{ (filteredTrailers | async)?.length }}
              of {{ (allTrailers | async)?.length }} trailers.
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="(isAdmin | async) ? '11' : '10'">
              <span *ngIf="loading">Loading Trailers...</span>
              <span *ngIf="!loading && !(allTrailers | async)">Use form to add a new empty trailer.</span>
              <span *ngIf="!loading && (allTrailers | async).length">No trailers match the search parameters.</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>

<ship-load (loadUpdated)="loadShipped($event)" [(show)]="showShipLoad" [load]="loadToShip"></ship-load>

<p-dialog
  [(visible)]="showTrailerUpdateDialog"
  [blockScroll]="true"
  appendTo="body"
  header="Update Trailer {{selectedTrailer?.trailerNumber}}">

  <div class="p-grid" [formGroup]="departForm">
    <div class="form-group p-col-12 p-lg-6">
      <label class="required" for="departedAtDate">Departed Date</label>
      <p-calendar
        formControlName="departDate"
        class="form-control"
        appendTo="body"
        name="departedAtDate">
      </p-calendar>
      <error-block [field]="departForm.controls.departDate" [messages]="{
        required: 'Departed Date is required.'
      }"></error-block>
    </div>
    <div class="form-group p-col-12 p-lg-6">
      <label class="required" for="departedAtTime">Departed Time</label>
      <time-entry
        formControlName="departTime"
        [displaySeconds]="false"
        [timezone]="siteTimezone"
        name="departedAtTime">
      </time-entry>
      <error-block [field]="departForm.controls.departDate" [messages]="{
        required: 'Departed Date is required.'
      }"></error-block>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" (click)="showTrailerUpdateDialog = false" class="p-button-secondary"></button>
    <button pButton type="button" label="Update" (click)="confirmTrailerUpdate($event)"></button>
  </ng-template>
</p-dialog>
